/**
 * Gestione Mense Backend Authentication API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { StudenteInfo } from './studenteInfo';

export interface RicaricaReportView { 
    verificaInRitardo?: boolean;
    metodoPagamento?: string;
    operatore?: string;
    pagamentoDaVerificare?: boolean;
    numeroBollettino?: string;
    studente?: StudenteInfo;
    dataPagamento?: string;
    valore?: number;
    statoInterno?: RicaricaReportView.StatoInternoEnum;
    numeroAvviso?: string;
    identificativoUnivocoVersamento?: string;
    note?: string;
    stato?: string;
    id?: string;
    data?: Date;
}
export namespace RicaricaReportView {
    export type StatoInternoEnum = 'GENERAZIONE_IN_CORSO' | 'IN_ATTESA_PAGAMENTO' | 'PAGATA' | 'ERRORE' | 'CANCELLATA';
    export const StatoInternoEnum = {
        GENERAZIONEINCORSO: 'GENERAZIONE_IN_CORSO' as StatoInternoEnum,
        INATTESAPAGAMENTO: 'IN_ATTESA_PAGAMENTO' as StatoInternoEnum,
        PAGATA: 'PAGATA' as StatoInternoEnum,
        ERRORE: 'ERRORE' as StatoInternoEnum,
        CANCELLATA: 'CANCELLATA' as StatoInternoEnum
    };
}